// Author YuJiaBei
// Date 2020-11-12 10:33:16

class InspectionWay {
constructor({
        id = null,
        name = '',
        description = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.description = description;
}
}

function newEntity() {
return new InspectionWay();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.em.inspection.inspectionWay.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.em.inspection.inspectionWay.grid.description',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.inspection.inspectionWay.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.inspection.inspectionWay.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'description',
        label: 'label.em.inspection.inspectionWay.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {InspectionWay, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
